import { apiRequest } from "./client";

export const projectsApi = {
  list() {
    return apiRequest("/projects");
  },

  create(payload) {
    return apiRequest("/projects", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  get(projectId) {
    return apiRequest(`/projects/${projectId}`);
  },

  getDeployment(projectId) {
    return apiRequest(`/projects/${projectId}/deployment`);
  },

  retryDeployment(projectId) {
    return apiRequest(`/projects/${projectId}/deployment/retry`, {
      method: "POST",
    });
  },

  update(projectId, payload) {
    return apiRequest(`/projects/${projectId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  listMembers(projectId) {
    return apiRequest(`/projects/${projectId}/members`);
  },

  addMember(projectId, payload) {
    return apiRequest(`/projects/${projectId}/members`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  removeMember(projectId, memberId) {
    return apiRequest(`/projects/${projectId}/members/${memberId}`, {
      method: "DELETE",
    });
  },
};
